import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicComingSoon({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 1075 435"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M493 276.79c39.57-.33 63.3-14.67 71.19-43.04 11.82-42.55 52.79-74.6 74.3-37.3a494.9 494.9 0 0136.97 80.34v65.8c60.26 11.57 102.12 6.76 125.57-14.43 35.17-31.78 84.2-64.17 143.37-14.88 39.44 32.86 82.97 60.43 130.6 82.72H874.94L493 371.74v-94.95zM364.77 12.92c17.53-16.8 44.12-21.94 55.6 14.01 11.49 35.96 9.32 34.36 18.34 63.47 9.02 29.1 22.43 119.98 0 144.67-14.96 16.46-39.6-18.75-73.94-105.63-11.7-66.49-11.7-105.33 0-116.52z"
          fill="#EAEDF6"
        />
        <path
          d="M921 396c-24.5-23.52-63.35-35.28-116.55-35.28-79.79 0-104.2-66.15-104.2-82.43 0-59.3-101.98-59.3-101.98 0 0 82.64-80.63 82.64-80.63 0 0-82.63-81.98-94.93-100.89-134.51C397.85 104.2 405.72 32 370.61 32c-35.1 0-37.84 69.09-37.84 111.78 0 42.7-42.87 73.34-64.24 16.48-21.36-56.85-77.66-112.1-97.63-56.04-19.96 56.04-28.44 78.33-96.66 140.89-45.47 41.7-70.22 92-74.24 150.9h921z"
          fill="#FFF6CC"
        />
        <path
          d="M882.29 313.28l-.7 13.21-2.17 33.8a2.4 2.4 0 01-2.4 2.28h-44.81a2.4 2.4 0 01-2.4-2.28l-2.17-33.8-.7-13.21h55.35"
          fill="#56A"
        />
        <path
          d="M823.1 312.7a31.57 31.57 0 0131.52-31.52 31.57 31.57 0 0131.52 31.52v3.9h-2.71v3.35h2.74a3.32 3.32 0 003.32-3.32v-3.93a34.88 34.88 0 10-69.75 0v3.93a3.31 3.31 0 003.31 3.32h2.76v-3.35h-2.72v-3.9z"
          fill="#4A557B"
          fillRule="nonzero"
        />
        <path
          d="M861.55 282.99a28.15 28.15 0 00-13.87 0c-1 .25-2.02-.31-2.34-1.3l-.54-1.64a1.96 1.96 0 011.38-2.5 33.79 33.79 0 0116.87 0 1.96 1.96 0 011.38 2.5l-.53 1.64a1.96 1.96 0 01-2.35 1.3"
          fill="#FFF"
        />
        <path
          d="M883.53 323.41H825.7a2.33 2.33 0 01-2.33-2.33v-5.47a2.33 2.33 0 012.33-2.33h57.83a2.33 2.33 0 012.33 2.33v5.47a2.33 2.33 0 01-2.33 2.33"
          fill="#56A"
        />
        <path
          fill="#4A557B"
          fillRule="nonzero"
          opacity={0.8}
          d="M830.95 328.5l-.3-5.09h51.1l-.28 5.08z"
        />
        <path
          d="M839.82 313.28c.14 3.5 1.8 5.8 5 6.91a4.64 4.64 0 005.34-1.38c.82-.93.78-1.73 1.73-1.73.96 0 1.73.77 1.73 1.73v1.8a1.73 1.73 0 103.46 0v-2.59a1.73 1.73 0 113.45 0v3.53a1.73 1.73 0 103.46 0v-5.5c0-2.22 3.25-2.22 3.25-.54 0 1.57 3.43 2.3 4.61.78.38-.48 1.03-1.48 1.97-3.01h-34z"
          fill="#FFE98A"
        />
        <path
          fill="#374681"
          opacity={0.3}
          d="M834.5 362.57l-3.36-34.08h5.81l6 34.08zm1.7-39.17h-5.55l-1-10.12h4.81l1.75 10.13"
        />
        <path fill="#56A" d="M703.09 23.26l-47.43 8.15.85 4.97 47.43-8.14-.85-4.98" />
        <path
          d="M699.95 32.49l-2.03-11.84a3.2 3.2 0 00-3.68-2.6l-36.6 6.27a3.2 3.2 0 00-2.6 3.69l2.04 11.83a3.19 3.19 0 003.67 2.6l36.6-6.27a3.19 3.19 0 002.6-3.68"
          fill="#FFE98A"
        />
        <path
          d="M683.85 23.26c-5.99 1.46-3.25 8.17-11.69 9.62-8.44 1.44-14.7-1.45-17.16-6.38a4 4 0 012.83-2.2l36.8-6.3c.63.07 1.64.07 2.22.81.48.8-1.53 5.07-5.27 5.5-3.74.42-3.9-1.98-7.73-1.05z"
          fill="#FFF6CC"
        />
        <path
          d="M687.76 64.82a3.6 3.6 0 00-.61 2.7l6.4 37.3-4.68.81-6.6-38.49a5.5 5.5 0 01.93-4.1l21.57-18.68a3.6 3.6 0 00.61-2.69l-3.13-18.26 2.19-.38a2.53 2.53 0 012.92 2.07l2.9 16.95a5.49 5.49 0 01-.92 4.1l-21.58 18.67z"
          fill="#56A"
        />
        <path
          d="M694.28 107.94a1.93 1.93 0 11-3.8.65 1.93 1.93 0 013.8-.65m3.6 2.77l-5.21-30.37a1.76 1.76 0 00-2.03-1.43l-6.39 1.1a1.75 1.75 0 00-1.43 2.02l5.2 30.37c.17.95 1.08 1.6 2.03 1.43l6.4-1.1a1.75 1.75 0 001.42-2.02"
          fill="#666"
        />
        <path
          fill="#EFEFEF"
          d="M696.28 101.41l-9.85 1.7.23 1.33 9.85-1.69-.23-1.34m-.65-3.79l-9.85 1.69.23 1.34 9.85-1.7-.23-1.33m-.65-3.79l-9.85 1.69.23 1.33 9.85-1.68-.23-1.34"
        />
        <path fill="#50A1DE" d="M689.33 76.41l-.1-.61.1.61" />
        <path
          d="M824.67 194.8l11.64-11.12 20.23 27.26a10.6 10.6 0 012.08 6.33l-.05 54.53-7.78-1.19-3.66-46.74a7.78 7.78 0 00-1.79-4.39l-20.67-24.68"
          fill="#FFD9CC"
        />
        <path
          d="M861.53 276.5l-11.5 1.46-.74-2.84-1.69 1.87c-.46.5-1.12.76-1.8.7h-.03a1.15 1.15 0 01-.8-1.85l5.94-7.7 7.66-.45.66 1.2c1.1 2 1.82 4.19 2.14 6.45l.16 1.16"
          fill="#FFD9CC"
        />
        <path
          d="M849.96 285.3h-.13a1.52 1.52 0 01-1.42-1.61l.48-7.64c.06-.83.78-1.47 1.61-1.41h.13c.84.06 1.47.78 1.42 1.61l-.48 7.63a1.52 1.52 0 01-1.61 1.42"
          fill="#FFD9CC"
        />
        <path
          d="M853.12 285.5h-.14a1.52 1.52 0 01-1.41-1.62l.48-7.63a1.5 1.5 0 011.6-1.41h.14c.84.06 1.47.78 1.42 1.61l-.48 7.63a1.52 1.52 0 01-1.61 1.42"
          fill="#FFD9CC"
        />
        <path
          d="M856.27 285.7h-.13a1.52 1.52 0 01-1.41-1.62l.48-7.63a1.5 1.5 0 011.6-1.41h.14c.83.06 1.47.78 1.42 1.61l-.49 7.63a1.52 1.52 0 01-1.6 1.42"
          fill="#FFD9CC"
        />
        <path
          d="M859.43 285.9h-.13a1.52 1.52 0 01-1.42-1.62l.49-7.63a1.5 1.5 0 011.6-1.41h.14c.83.06 1.47.78 1.41 1.61l-.48 7.63a1.52 1.52 0 01-1.6 1.42M745.2 162.7l-8.26 13.83-32.45-21.42a8.43 8.43 0 01-3.66-5.61l-8.87-51.93 7.81-.94 11.48 43.36a7.78 7.78 0 003.55 4.7l30.4 18.02"
          fill="#FFD9CC"
        />
        <path
          d="M697.68 82.3a2.08 2.08 0 00-2.05-1.7l-.63.01c-1.31 0-2.3 1.2-2.04 2.5l1.17 5.83a2.5 2.5 0 01-2.7 2.98l-6.9-.69a3.14 3.14 0 00-3.45 3.13l.03 8.21a3.14 3.14 0 003.15 3.13l12.02-.03c1.77 0 3.28-1.3 3.57-3.04l1.23-7.6c.22-1.38.1-2.8-.37-4.11l-3.03-8.62m96.62 64.99h-10.2l-.68 16.84h11.56l-.67-16.84"
          fill="#FFD9CC"
        />
        <path
          d="M809.81 141.75l5.49-11.95a20.24 20.24 0 00-11.74-27.55l-.5-.18a23.26 23.26 0 00-30.88 20.63l-1.07 18.69a5.02 5.02 0 003.8 5.16l16.45 4.09a16.05 16.05 0 0018.45-8.89"
          fill="#FFD9CC"
        />
        <path
          d="M794.02 151.07c-.88-.07-1.78-.21-2.66-.43l-7.02-1.75 9.4.97.28 1.2"
          fill="#EBC8BC"
        />
        <path
          d="M795.24 152.33l3.45-.27a13.42 13.42 0 0010.49-6.46l.73-1.23a39.21 39.21 0 004.02-9.16l3.94-13.4c1.1-3.78.63-7.86-1.32-11.28l-.06-.1a16.33 16.33 0 00-6.98-6.56l-5.7-2.8a21.42 21.42 0 00-14.7-1.55l-5.99 1.52a9.1 9.1 0 00-5.24 3.62l-.05.08a6.39 6.39 0 001.33 8.7l4.48 3.47a6.17 6.17 0 004.54 1.25l2.31-.3c1.58-.2 3.13.53 3.99 1.87l.02.04c.85 1.32.87 3 .08 4.33l-2.52 4.24-1.35 2.3A15.44 15.44 0 00789.3 143l.03.08c.3.95.36 1.96.2 2.94l-.01.08a5.39 5.39 0 005.73 6.24"
          fill="#666"
        />
        <path d="M772.26 121.85l-3.55 6.17c-.2.36-.1.82.25 1.04l3.75 2.4-.45-9.61" fill="#FFD9CC" />
        <path
          d="M772.83 99.44l9.26-3.54a37.08 37.08 0 0121.41-1.53l.32.07a25.06 25.06 0 0113.07 7.65l.1.1a15.08 15.08 0 013.78 11.85l-1.07 9.2a22.1 22.1 0 01-2.3 7.56l-.03.06a2.62 2.62 0 01-3.97.86l-40.57-32.28"
          fill="#FFF"
        />
        <path
          d="M779.7 104.84l-11.47-5.33a8.37 8.37 0 01-4.72-7.63v-1.94a7.48 7.48 0 014.97-7.07l.08-.03a4.41 4.41 0 014.65 1.09l17.96 18.57-11.46 2.34"
          fill="#FFF"
        />
        <path
          d="M754.95 429.65l-.13.73.3 1.4a2.12 2.12 0 01-2.08 2.56h-11.8a2.12 2.12 0 01-2.1-2.41l.27-1.97-4.54-6.73a8.54 8.54 0 01-1.32-6.24l.52-2.94a3.73 3.73 0 014.88-2.88l6.92 2.36 7.8 5.86a5.54 5.54 0 012.13 5.38l-.85 4.88"
          fill="#666"
        />
        <path
          d="M751.55 422.4h-10.43c-.92 0-1.66-.75-1.66-1.66l.63-4.9h14.37l-1.25 4.9c0 .91-.74 1.66-1.66 1.66"
          fill="#FFD9CC"
        />
        <path
          d="M753.04 434.34h-11.8a2.13 2.13 0 01-2.1-2.42v-.04a5.08 5.08 0 00-.81-3.53l-3.46-5.12a8.54 8.54 0 01-1.42-5.53l6.33 10.2a3.7 3.7 0 003.14 1.75h12.03l-.13.73.3 1.4a2.12 2.12 0 01-2.08 2.56"
          fill="#333532"
          opacity={0.5}
        />
        <path
          d="M823.73 429.65l.12.73-.29 1.4a2.12 2.12 0 002.08 2.56h11.79a2.12 2.12 0 002.1-2.41l-.26-1.97 4.53-6.73a8.54 8.54 0 001.33-6.24l-.52-2.94a3.73 3.73 0 00-4.88-2.88l-6.92 2.36-7.8 5.86a5.54 5.54 0 00-2.14 5.38l.86 4.88"
          fill="#666"
        />
        <path
          d="M827.13 422.4h10.43c.91 0 1.66-.75 1.66-1.66l-.63-4.9h-14.37l1.25 4.9c0 .91.74 1.66 1.66 1.66"
          fill="#FFD9CC"
        />
        <path
          d="M825.64 434.34h11.79a2.13 2.13 0 002.1-2.42v-.04c-.17-1.24.12-2.5.82-3.53l3.45-5.12a8.54 8.54 0 001.43-5.53l-6.33 10.2a3.7 3.7 0 01-3.15 1.75h-12.02l.12.73-.29 1.4a2.12 2.12 0 002.08 2.56"
          fill="#333532"
          opacity={0.5}
        />
        <path
          d="M825.82 277.7c0 .8.1 2.35.27 4.55.1 1.42.24 3.1.4 5h-74.6c.16-1.9.3-3.58.4-5 .18-2.2.27-3.76.27-4.55v-82.4c0-2.04-1-3.95-2.66-5.12l-22.05-15.58 9.35-20.67 27.72 9.84 7.88-2.22.48-1.54a3.29 3.29 0 012.41-2.24l8.05-1.87h10.9l7.95 1.79c1.1.25 2 1.05 2.37 2.1l.62 1.76 16.16 4.55a14.9 14.9 0 016.95 4.28l18.8 21.82-13.19 18.57-8.48-7.57v74.5"
          fill="#FFF"
        />
        <path
          d="M825.82 271.5v-11.46l-5.27 2a23.2 23.2 0 01-17.45-.43l-2.8-1.22 13.16-96.62-7.88-2.22-14.78 96.96h-3.21l-14.79-96.96-7.88 2.22 13.16 96.62-3.13 1.31a23.2 23.2 0 01-17.18.31l-5.2-1.97v11.06h-.01c-1.93 25.46-14.37 148.02-14.37 148.02h17.04l24.42-98.77c1-4.03 3.31-7.6 6.58-10.16l.08-.06a4.68 4.68 0 015.76 0l.09.06a18.52 18.52 0 016.57 10.15l24.42 98.78h17.04s-12.43-122.13-14.37-147.62"
          fill="#56A"
        />
        <path
          fill="#999"
          d="M182.4 78.17h98.65V66.99H182.4zm-7.22 69.33h113.08v-11.2H175.18zm0 69.32h113.08v-11.18H175.18zm-5.56 69.32h124.21v-11.19H169.62zM167 355.46h129.46v-11.18H166.99z"
        />
        <path
          d="M299.65 421.2a6.15 6.15 0 005.8-6.48L283.21 15.58a3.78 3.78 0 00-3.98-3.57l-4.73.26a3.78 3.78 0 00-3.56 3.99l22.22 399.14a6.15 6.15 0 006.48 5.8m-135.84 0a6.15 6.15 0 01-5.79-6.48l22.21-399.14a3.78 3.78 0 014-3.57l4.71.26a3.78 3.78 0 013.57 3.99L170.28 415.4a6.14 6.14 0 01-6.48 5.8"
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgPicComingSoon.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicComingSoon.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicComingSoon svgRef={ref} {...props} />);
export default ForwardRef;
